import { Component, Input } from '@angular/core';

// services
import { TranslateService } from '@ngx-translate/core';
import { FocusStackService } from '@app/shared/services/focus-stack.service';

// types
import { MenuViewModel } from '@app/shared/components/menu/menu.component';

@Component({
  selector: 'dgx-add-menu-v2',
  templateUrl: './add-menu.component.html',
})
export class AddMenuV2 {
  @Input() public menuConfig: MenuViewModel[];
  @Input() public linkText: string = '';
  public adjustment: number = -1.5;

  public i18n = this.translateService.instant(['Core_Add']);

  constructor(
    private translateService: TranslateService,
    private focusStackService: FocusStackService
  ) {}

  public ngOnInit(): void {
    if (this.linkText) {
      this.adjustment = -3.5;
    }
  }

  public setFocus() {
    this.focusStackService.push();
  }
}
